export default __webpack_public_path__ + "static/media/009-giraffe.6eae3a06.svg";